import { useState } from "react";
import { useTranslation } from "react-i18next";

// react-router-dom components
import { Link } from "react-router-dom";
// @mui material components
import { IconButton, InputAdornment } from "@mui/material";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDAvatar from "components/MDAvatar";

// Authentication layout components
import AuthLayout from "layouts/authentication/components/AuthLayout";

// third party
import * as Yup from "yup";
import { Formik } from "formik";

// Images & icons
import bgImage from "assets/images/bg-pattern.svg";
import logo from "assets/images/logos/logo.png";
import { ReactComponent as ShowIcon } from "assets/images/icons/show.svg";
import { ReactComponent as HiddenIcon } from "assets/images/icons/hidden.svg";
import MDCard from "components/MDCard";

// Material Dashboard 2 React base styles
import colors from "assets/theme/base/colors";
import pxToRem from "assets/theme/functions/pxToRem";

function Basic() {
  const [rememberMe, setRememberMe] = useState(false);

  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const { background } = colors;
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const { t } = useTranslation();
  return (
    <AuthLayout image={bgImage}>
      <MDCard
        sx={({ breakpoints }) => ({
          backgroundColor: background.pale,
          borderRadius: "48px !important",
          height: "74vh",

          [breakpoints.up("xl")]: {
            width: "35vw",
          },
          [breakpoints.down("xl")]: {
            width: "auto",
            mx: 3,
            p: 0,
          },
        })}
      >
        <MDBox pt={4} pb={2} px={3}>
          <MDBox display="flex" justifyContent="center">
            <MDAvatar
              src={logo}
              sx={({ breakpoints }) => ({
                width: pxToRem(200),
                height: pxToRem(200),

                [breakpoints.down("xl")]: {
                  width: pxToRem(128),
                  height: pxToRem(128),
                },
              })}
            />
          </MDBox>
          <MDTypography
            textAlign="center"
            variant="h4"
            fontWeight="medium"
            color="info"
            mb={2}
            mt={2}
          >
            {t("headings.signIn")}
          </MDTypography>
          <Formik
            initialValues={{
              phone: "0902232435",
              password: "123456",
              submit: null,
            }}
            validationSchema={Yup.object().shape({
              phone: Yup.string().max(11).required("شماره همراه الزامی است"),
              password: Yup.string().max(255).required("پسورد الزامی است"),
            })}
            onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
              try {
              } catch (err) {
                console.error(err);
              }
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values,
            }) => (
              <MDBox component="form" role="form">
                <MDInput
                  fullWidth
                  formError={touched.email && errors.email}
                  label={t("labels.phone")}
                  size="small"
                  id="outlined-adornment-email-login"
                  type="email"
                  value={values.email}
                  name="email"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  inputProps={{}}
                  sx={{ mb: !errors.email && 4 }}
                  error={errors.email}
                />
                <MDInput
                  fullWidth
                  formError={touched.password && errors.password}
                  label={t("labels.password")}
                  size="small"
                  id="outlined-adornment-password-login"
                  type={showPassword ? "text" : "password"}
                  value={values.password}
                  name="password"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  inputProps={{}}
                  error={errors.password}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                        size="large"
                      >
                        {showPassword ? (
                          <ShowIcon style={{ width: pxToRem(24), height: pxToRem(24) }} />
                        ) : (
                          <HiddenIcon style={{ width: pxToRem(24), height: pxToRem(24) }} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
                <MDBox textAlign="right">
                  <MDTypography
                    fontSize="sm"
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    onClick={handleSetRememberMe}
                    sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                  >
                    &nbsp;&nbsp;{t("buttons.forget")}
                  </MDTypography>
                </MDBox>
                <MDBox mt={4} mb={1}>
                  <MDButton
                    variant="gradient"
                    fullWidth
                    href="/dashboard"
                    sx={{ height: pxToRem(52) }}
                  >
                    {t("buttons.signIn")}
                  </MDButton>
                </MDBox>
                <MDBox mt={3} mb={1} textAlign="center">
                  <MDTypography variant="button" color="text" fontSize="sm">
                    {t("captions.noAccount")}{" "}
                    <MDTypography
                      component={Link}
                      to="/authentication/sign-up"
                      variant="button"
                      color="primary"
                      fontWeight="medium"
                      textGradient
                      fontSize="xs"
                    >
                      {t("buttons.signUp")}
                    </MDTypography>
                  </MDTypography>
                </MDBox>
              </MDBox>
            )}
          </Formik>
        </MDBox>
        <MDBox mb={-5} mt={1} display="flex" justifyContent="flex-end" alignItems="center">
          <MDTypography
            variant="button"
            fontWeight="regular"
            color="primary"
            sx={{ cursor: "pointer", userSelect: "none", mr: 3 }}
            fontSize="sm"
          >
            {t("buttons.guide")}
          </MDTypography>
          <MDTypography
            variant="button"
            fontWeight="regular"
            color="primary"
            sx={{ cursor: "pointer", userSelect: "none" }}
            fontSize="sm"
          >
            {t("buttons.rule")}
          </MDTypography>
        </MDBox>
      </MDCard>
    </AuthLayout>
  );
}

export default Basic;
